<!-- Start Body Section -->
<div id="cm__main-content" class="single-brand">
  <!-- Start Page Title -->
  <div class="cm__container is-fullwidth is-adjacent">
    <div class="cm__container__col"></div>
  </div>
  <!-- End Page Title -->
  <div class="cm__container is-7030">
    <!-- Start Left Section -->
    <div class="cm__container__col">
      <!-- Start BOB Placeholder -->
      <ng-container #WidgetContractsComponent></ng-container>
      <div *ngIf="this.isAuthorized" class="bob-block"></div>
      <!-- End BOB Placeholder -->
      <!-- Start Product tab Placeholder -->
      <app-product-tabs></app-product-tabs>
      <!-- End Product tab Placeholder -->
      <div class="lowres-right-section">
        <div class="cm__container is-5050" *ngIf="windowIsSmall">
          <!-- Start Rate Caps Placeholder -->
          <div class="cm__container__col">
            <app-ratecap></app-ratecap>
          </div>
          <!-- End Rate Caps Placeholder -->
          <!-- Start Contact Placeholder -->
          <div class="cm__container__col">
            <app-contact-wholesaler></app-contact-wholesaler>
          </div>
          <!-- End Contact Placeholder -->
        </div>
      </div>
      <!-- Start Banners Placeholder -->
      <app-promotions-widget></app-promotions-widget>
      <!-- End Banners Placeholder -->
      <!-- Start News Placeholder -->
      <app-news-widget></app-news-widget>
      <!-- End News Placeholder -->
    </div>
    <!-- End Left Section -->
    <!-- Start Right Section -->
    <div class="cm__container__col highres-right-section">
      <div class="" *ngIf="!windowIsSmall">
        <!-- Start Rate Caps Placeholder -->
        <app-ratecap></app-ratecap>
        <!-- End Rate Caps Placeholder -->
        <!-- Start Contact Placeholder -->
        <app-contact-wholesaler></app-contact-wholesaler>
        <!-- End Contact Placeholder -->
      </div>
    </div>
    <!-- End Right Section -->
  </div>
</div>
<!-- End Body Section -->
